export const kMetricValueTypes = [
    'number',
    'percent',
    'duration',
    'score',
    'range',
    'text',
] as const;

export const kTrendStrategyKeys = [
    'default',
    'higher-is-better',
    'lower-is-better',
    'stable',
] as const;

export const HEX_COLOR_RE = /^#[0-9A-Fa-f]{6}$/;

export interface LevelRange {
    min: number;
    max: number;
}

export function levelsOverlap(a: LevelRange, b: LevelRange): boolean {
    return a.min <= b.max && b.min <= a.max;
}

export function findOverlappingLevels(levels: LevelRange[]): string | null {
    for (let i = 0; i < levels.length; i++) {
        for (let j = i + 1; j < levels.length; j++) {
            if (levelsOverlap(levels[i], levels[j])) {
                return `Levels ${i + 1} and ${j + 1} overlap`;
            }
        }
    }
    return null;
}
